import React from "react";
import {
  TextField,
  Typography,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  useTheme,
} from "@mui/material";
import { CompanyIdIssuanceInputForm } from "IF/interfaceType";

interface CompanyInfoRowProps {
  open: boolean;
  handleClose: () => void;
  form: CompanyIdIssuanceInputForm;
  handleInput: () => void;
  inputHandleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CompanyIdIssuanceRegister: React.FC<CompanyInfoRowProps> = ({
  open,
  handleClose,
  form,
  handleInput,
  inputHandleChange,
}) => {
  const theme = useTheme();
  return (
    <Dialog open={open} onClose={handleClose}>
      <Box
        sx={{
          padding: "10px 10px",
          backgroundColor: theme.palette.custom.sForm,
          border: `3px solid ${theme.palette.custom.paperBorderColor}`,
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Typography
            fontWeight="fontWeightBold"
            sx={{
              display: "inline-block",
            }}
          >
            契約企業登録
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pb: 0.5 }}>
          <Box
            component="form"
            onSubmit={handleInput}
            sx={{ display: "flex", flexDirection: "column", gap: 0.5, mb: 0 }}
          >
            <TextField
              size="small"
              fullWidth
              id="companyCode"
              label="企業コード（16進数）"
              name="companyCode"
              value={form.companyCode}
              onChange={inputHandleChange}
              margin="dense"
              variant="outlined"
              inputProps={{ maxLength: 8 }}
              InputLabelProps={{
                shrink: true,
                sx: {
                  fontWeight: "bold",
                },
              }}
            />
            <TextField
              required
              size="small"
              fullWidth
              id="companyName"
              label="企業名"
              name="companyName"
              value={form.companyName}
              onChange={inputHandleChange}
              margin="dense"
              variant="outlined"
              inputProps={{ maxLength: 255 }}
              InputLabelProps={{
                shrink: true,
                sx: {
                  fontWeight: "bold",
                },
              }}
            />
            <TextField
              required
              size="small"
              fullWidth
              type="number"
              id="mailSendLimit"
              label="配信可能人数（メール）"
              name="mailSendLimit"
              value={form.mailSendLimit}
              onChange={inputHandleChange}
              margin="dense"
              variant="outlined"
              inputProps={{ maxLength: 255, min: 0 }}
              InputLabelProps={{
                shrink: true,
                sx: {
                  fontWeight: "bold",
                },
              }}
            />
            <TextField
              required
              size="small"
              fullWidth
              type="number"
              id="smsSendLimit"
              label="配信可能人数（SMS）"
              name="smsSendLimit"
              value={form.smsSendLimit}
              onChange={inputHandleChange}
              margin="dense"
              variant="outlined"
              inputProps={{ maxLength: 255, min: 0 }}
              InputLabelProps={{
                shrink: true,
                sx: {
                  fontWeight: "bold",
                },
              }}
            />
          </Box>
          <Typography
            fontWeight="fontWeightLight"
            sx={{
              display: "inline-block",
              pt: 0.5,
            }}
          >
            ※企業コードは未入力の場合自動生成されます。
          </Typography>
        </DialogContent>
        <DialogActions sx={{ pt: 1 }}>
          <Button onClick={handleClose}>キャンセル</Button>
          <Button onClick={handleInput} variant="contained">
            登録
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default CompanyIdIssuanceRegister;
